import { actionToNavigationRoute } from '@nextforce/api'
import { flatMap } from 'lodash'
import { Platform } from 'react-native'
import { ToolsResponse } from './response'
import { ToolsData } from './types'

export function convertTools(response: ToolsResponse.Tools): ToolsData {
  const tools = flatMap(response.actions, (action, index: number) => {
    if (
      !action.title ||
      action.name === 'profile' ||
      action.name === 'settings' ||
      action.name === 'chat' ||
      action.name === 'upload_files' ||
      action.name === 'webview' ||
      (Platform.OS === 'web' &&
        (action.name === 'scan_login_qr' ||
          action.name === 'text_only_download_crew'))
    ) {
      return []
    }

    const route = actionToNavigationRoute(action)

    return [
      {
        id: String(index + 1),
        name: action.name,
        title: action.title,
        iconUrl: action.icon_url,
        route,
      },
    ]
  })

  return { tools }
}
